(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8893],{

/***/ 25216:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit-consult/request",
      function () {
        return __webpack_require__(32305);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ request; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./src/components/AppLayout/index.tsx + 40 modules
var AppLayout = __webpack_require__(42413);
// EXTERNAL MODULE: ./src/components/LoadImage/index.tsx + 3 modules
var LoadImage = __webpack_require__(16647);
// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-0bfff5899a/0/cache/@design-system-pc-npm-4.5.5-5209ca23ee-508cb735dc.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(56341);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-hook-form-virtual-e700c25d77/0/cache/react-hook-form-npm-7.36.1-ea95e51e7c-d41951685f.zip/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(46996);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/components/AgreementPopup/VisitPersonalInfoCollection.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 0px 40px 40px 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  white-space: pre-wrap;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-top: 20px;\n  margin-bottom: 40px;\n  border-top: 1px solid ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 360px;\n  height: 64px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  height: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  white-space: pre-wrap;\n  color: ",
        ";\n  ",
        ";\n  p {\n    color: ",
        ";\n    ",
        ";\n    text-decoration: underline;\n    text-underline-offset: 3px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  vertical-align: top !important;\n  border-left: 1px solid ",
        ";\n  :first-child {\n    border-left: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var CONTENT = [
    {
        id: 1,
        title: "수집 및 이용 목적",
        children: [
            "상담 및 견적서비스 이행\n      (상담신청, 해피콜, 상담 매장 및 영업사원 배정,\n        견적 서비스 제공)", 
        ]
    },
    {
        id: 2,
        title: "수집 항목",
        children: [
            "이름, 주소,휴대폰번호"
        ]
    },
    {
        id: 3,
        title: "보유 및 이용 기간",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "회원탈퇴 시"
            }, ")")
        ]
    }, 
];
var CONTENT_EVENT = [
    {
        id: 1,
        title: "수집 및 이용 목적",
        children: [
            "상담 및 견적서비스 이행\n      (상담신청, 해피콜, 상담 매장 및 영업사원 배정,\n      견적 서비스 제 공), 제품 설치",
            "이벤트 참여자 문의 안내, 당첨자 개별 연락 및 안내,\n      사은품 배송, 본인 확인", 
        ]
    },
    {
        id: 2,
        title: "수집 항목",
        children: [
            "이름, 주소,휴대폰번호"
        ]
    },
    {
        id: 3,
        title: "보유 및 이용 기간",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "회원탈퇴 시"
            }, ")")
        ]
    }, 
];
var VisitPersonalInfoCollection = function(param) {
    var isMember = param.isMember, isEvent = param.isEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, _objectSpreadProps(_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_agree_content")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextDefault, {
                children: "매장 상담 예약 서비스 제공을 위해 고객님의 개인정보를 수집 및 이용하고자 합니다.\n아래의 개인정보 수집 및 이용 동의를 거부할 권리가 있으나 동의를 거부하실 경우 매장 상담 예약이 불가합니다."
            }),
            isEvent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tr, {
                        children: CONTENT_EVENT.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableData, {
                                    type: "head",
                                    children: item.title
                                })
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tr, {
                        children: CONTENT_EVENT.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody, {
                                rowSpan: 2,
                                children: item.children.map(function(val, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableData, {
                                        type: "body",
                                        height: item.children.length !== 2 ? "200px" : "100px",
                                        children: item.id === 3 ? isMember ? val : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "1년"
                                        }) : val
                                    }, idx);
                                })
                            }, item.id);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tr, {
                        children: CONTENT.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableData, {
                                    type: "head",
                                    children: item.title
                                })
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tr, {
                        children: CONTENT.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableData, {
                                    type: "body",
                                    children: item.id === 3 ? isMember ? item.children : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "1년"
                                    }) : item.children
                                })
                            }, item.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextDefault, {
                children: "* 서비스 이용과정에서 서비스이용기록, 접속로그, IP주소, 쿠키(Cookie), 기기정보가 자동으로 수집될 수 있습니다. 자세한 내용은 페이지 하단의 '개인정보 처리방침'을 확인하세요.\nhttp://mall.hanssem.com/customer/customerPrivacy.do"
            })
        ]
    }));
};
/* harmony default export */ var AgreementPopup_VisitPersonalInfoCollection = (VisitPersonalInfoCollection);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VisitPersonalInfoCollection__Container",
    componentId: "sc-8565890f-0"
})(_templateObject());
var TextDefault = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VisitPersonalInfoCollection__TextDefault",
    componentId: "sc-8565890f-1"
})(_templateObject1(), styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700], styles/* theme.typography.body2 */.rS.typography.body2);
var Content = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "VisitPersonalInfoCollection__Content",
    componentId: "sc-8565890f-2"
})(_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle5 */.rS.typography.subtitle5);
var TableHeader = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    displayName: "VisitPersonalInfoCollection__TableHeader",
    componentId: "sc-8565890f-3"
})(_templateObject3());
var TableData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VisitPersonalInfoCollection__TableData",
    componentId: "sc-8565890f-4"
})(_templateObject4(), function(param) {
    var type = param.type;
    return type === "body" ? "100px" : "100%";
}, styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200], function(param) {
    var height = param.height;
    return height;
}, styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle5 */.rS.typography.subtitle5);
var Tr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    displayName: "VisitPersonalInfoCollection__Tr",
    componentId: "sc-8565890f-5"
})(_templateObject5());
var TableBody = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    displayName: "VisitPersonalInfoCollection__TableBody",
    componentId: "sc-8565890f-6"
})(_templateObject6(), styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]);

// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(47046);
;// CONCATENATED MODULE: ./src/ui/Icons/RadioDisabledBlankIcon.tsx


function RadioDisabledBlankIcon(props) {
    var _boxSize, _boxSize1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "24",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "10",
                fill: "#F7F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                fill: "#E2E2E2"
            })
        ]
    });
}
/* harmony default export */ var Icons_RadioDisabledBlankIcon = (RadioDisabledBlankIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RadioDisabledCheckIcon.tsx


function RadioDisabledCheckIcon(props) {
    var _boxSize, _boxSize1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "24",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "10",
                fill: "#F7F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.1764 15.2741L7.30903 12.4068C7.01613 12.1139 7.01613 11.639 7.30903 11.3461C7.60192 11.0532 8.07679 11.0532 8.36969 11.3461L10.7067 13.6831L16.1868 8.20307C16.4797 7.91018 16.9545 7.91018 17.2474 8.20307C17.5403 8.49596 17.5403 8.97084 17.2474 9.26373L11.257 15.2541C11.2506 15.261 11.2441 15.2678 11.2374 15.2745C10.9445 15.5674 10.4696 15.5674 10.1767 15.2745L10.1764 15.2741Z",
                fill: "#E2E2E2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                fill: "#E2E2E2"
            })
        ]
    });
}
/* harmony default export */ var Icons_RadioDisabledCheckIcon = (RadioDisabledCheckIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RadioEnabledCheckIcon.tsx


function RadioEnabledIcon(props) {
    var _boxSize, _boxSize1, _fill, _fill1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "24",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "10",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.1759 15.2741L7.30854 12.4068C7.01564 12.1139 7.01564 11.639 7.30854 11.3461C7.60143 11.0532 8.0763 11.0532 8.3692 11.3461L10.7062 13.6831L16.1863 8.20307C16.4792 7.91018 16.9541 7.91018 17.2469 8.20307C17.5398 8.49596 17.5398 8.97084 17.2469 9.26373L11.2566 15.2541C11.2502 15.261 11.2436 15.2678 11.2369 15.2745C10.944 15.5674 10.4691 15.5674 10.1762 15.2745L10.1759 15.2741Z",
                fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#E2E2E2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                fill: (_fill1 = props.fill) !== null && _fill1 !== void 0 ? _fill1 : "#E2E2E2"
            })
        ]
    });
}
/* harmony default export */ var RadioEnabledCheckIcon = (RadioEnabledIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RadioFocusedCheckIcon.tsx


function RadioFocusedIcon(props) {
    var _boxSize, _boxSize1, _fill, _fill1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "24",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "10",
                fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.1759 15.2741L7.30854 12.4068C7.01564 12.1139 7.01564 11.639 7.30854 11.3461C7.60143 11.0532 8.0763 11.0532 8.3692 11.3461L10.7062 13.6831L16.1863 8.20307C16.4792 7.91018 16.9541 7.91018 17.2469 8.20307C17.5398 8.49596 17.5398 8.97084 17.2469 9.26373L11.2566 15.2541C11.2502 15.261 11.2436 15.2678 11.2369 15.2745C10.944 15.5674 10.4691 15.5674 10.1762 15.2745L10.1759 15.2741Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9.5",
                stroke: (_fill1 = props.fill) !== null && _fill1 !== void 0 ? _fill1 : "#121212"
            })
        ]
    });
}
/* harmony default export */ var RadioFocusedCheckIcon = (RadioFocusedIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RadioFocusedBlankIcon.tsx


function RadioFocusedBlankIcon(props) {
    var _boxSize, _boxSize1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "24",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "6.5",
                y: "6",
                width: "12",
                height: "12",
                rx: "6",
                fill: "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12.5",
                cy: "12",
                r: "9.5",
                stroke: "#121212"
            })
        ]
    });
}
/* harmony default export */ var Icons_RadioFocusedBlankIcon = (RadioFocusedBlankIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/RadioEnabledBlankIcon.tsx


function RadioEnabledBlankIcon(props) {
    var _boxSize, _boxSize1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "24",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
            cx: "12.5",
            cy: "12",
            r: "9.5",
            stroke: "#E2E2E2"
        })
    });
}
/* harmony default export */ var Icons_RadioEnabledBlankIcon = (RadioEnabledBlankIcon);

;// CONCATENATED MODULE: ./src/ui/RadioBox/RadioBox.tsx
function RadioBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RadioBox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RadioBox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RadioBox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RadioBox_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RadioBox_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function RadioBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RadioBox_templateObject() {
    var data = RadioBox_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  cursor: ",
        ";\n"
    ]);
    RadioBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var RadioBox = function(_param) {
    var _isChecked = _param.isChecked, isChecked = _isChecked === void 0 ? false : _isChecked, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = _param.onClick, label = _param.label, focusedFill = _param.focusedFill, enabledFill = _param.enabledFill, boxSize = _param.boxSize, _radioType = _param.radioType, radioType = _radioType === void 0 ? "arrow" : _radioType, props = _objectWithoutProperties(_param, [
        "isChecked",
        "disabled",
        "onClick",
        "label",
        "focusedFill",
        "enabledFill",
        "boxSize",
        "radioType"
    ]);
    var onClickRadioBox = function() {
        if (!disabled) {
            onClick && onClick();
        }
    };
    var RadioBoxRender = (0,react.useMemo)(function() {
        switch(radioType){
            case "arrow":
                {
                    if (disabled) {
                        return isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RadioDisabledCheckIcon, {
                            boxSize: boxSize
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RadioDisabledBlankIcon, {
                            boxSize: boxSize
                        });
                    } else {
                        return isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioFocusedCheckIcon, {
                            boxSize: boxSize,
                            fill: focusedFill
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioEnabledCheckIcon, {
                            boxSize: boxSize,
                            fill: enabledFill
                        });
                    }
                }
            case "blank":
                {
                    if (disabled) {
                        return isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RadioDisabledCheckIcon, {
                            boxSize: boxSize
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RadioDisabledBlankIcon, {
                            boxSize: boxSize
                        });
                    } else {
                        return isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RadioFocusedBlankIcon, {
                            boxSize: boxSize,
                            fill: focusedFill
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RadioEnabledBlankIcon, {
                            boxSize: boxSize,
                            fill: enabledFill
                        });
                    }
                }
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    }, [
        boxSize,
        isChecked,
        disabled,
        enabledFill,
        focusedFill,
        radioType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, RadioBox_objectSpreadProps(RadioBox_objectSpread({
        onClick: onClickRadioBox,
        disabled: disabled
    }, props), {
        children: [
            RadioBoxRender,
            label
        ]
    }));
};
/* harmony default export */ var RadioBox_RadioBox = (/*#__PURE__*/(0,react.memo)(RadioBox));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RadioBox__Wrapper",
    componentId: "sc-c63b09d9-0"
})(RadioBox_templateObject(), function(param) {
    var disabled = param.disabled;
    return disabled ? "default" : "pointer";
});

;// CONCATENATED MODULE: ./src/ui/RadioBox/index.ts


// EXTERNAL MODULE: ./src/utils/date.ts
var utils_date = __webpack_require__(77561);
;// CONCATENATED MODULE: ./src/constants/visit-consult.ts
var SELECTABLE_DATE_RANGE = 30;
var START_DATE_DIFF = 1;

;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/DateTimePopup.tsx
function DateTimePopup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DateTimePopup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DateTimePopup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DateTimePopup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function DateTimePopup_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        DateTimePopup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function DateTimePopup_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DateTimePopup_templateObject() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    DateTimePopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DateTimePopup_templateObject1() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 437px;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 28px 0px 28px;\n"
    ]);
    DateTimePopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DateTimePopup_templateObject2() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 20px 60px 0px 28px;\n"
    ]);
    DateTimePopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DateTimePopup_templateObject3() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    border-left: 1px solid ",
        ";\n    padding-top: 20px;\n    padding-left: 60px;\n  "
    ]);
    DateTimePopup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DateTimePopup_templateObject4() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    DateTimePopup_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DateTimePopup_templateObject5() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  flex-direction: column;\n  overflow: auto;\n  gap: 12px;\n  ",
        ";\n"
    ]);
    DateTimePopup_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DateTimePopup_templateObject6() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    height: 48px;\n    padding: 0px 16px;\n    cursor: pointer;\n    border-radius: 2px;\n    border: 1px solid ",
        ";\n  "
    ]);
    DateTimePopup_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = DateTimePopup_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










var today = new Date();
var startDate = new Date(today);
startDate.setDate(today.getDate() + START_DATE_DIFF);
var DateTimePopup = function(param) {
    var currentDate = param.currentDate, currentTime = param.currentTime, minDate = param.minDate, maxDate = param.maxDate, onChange = param.onChange, closeModal = param.closeModal, times = param.times;
    var ref = (0,react.useState)(currentDate), date = ref[0], setDate = ref[1];
    var ref1 = (0,react.useState)(currentTime), time = ref1[0], setTime = ref1[1];
    var selectedDate = (0,react.useMemo)(function() {
        return new Date(date);
    }, [
        date
    ]);
    var handleClickDatePicker = function(e) {
        var _dataset = e.currentTarget.dataset, year = _dataset.year, month = _dataset.month, date = _dataset.date;
        var calcMonth = "".concat(Number(month) < 10 ? "0" : "").concat(month);
        var calcDate = "".concat(Number(date) < 10 ? "0" : "").concat(date);
        year && month && date && setDate("".concat(year, "-").concat(calcMonth, "-").concat(calcDate));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, DateTimePopup_objectSpreadProps(DateTimePopup_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("visit_date_content")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DatePicker */.Mt, {
                            handleSelectDate: handleClickDatePicker,
                            selectDate: selectedDate,
                            isPreTodayDisabled: true,
                            minDate: minDate,
                            maxDate: maxDate,
                            width: "336px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "headline5",
                                color: styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"],
                                marginBottom: 24,
                                children: "희망 시간 선택"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeListBox, {
                                children: times.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TimeCard, DateTimePopup_objectSpreadProps(DateTimePopup_objectSpread({
                                        onClick: function() {
                                            return setTime(item);
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_time")), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "body1",
                                                color: styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"],
                                                width: "100%",
                                                children: (0,utils_date/* formatTimePeriod */.O)(item.timeCode)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioBox_RadioBox, DateTimePopup_objectSpread({
                                                disabled: false,
                                                isChecked: item.code === (time === null || time === void 0 ? void 0 : time.code),
                                                radioType: "blank"
                                            }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_time_button", {
                                                "option-value": item.code
                                            })))
                                        ]
                                    }), item.code);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, DateTimePopup_objectSpreadProps(DateTimePopup_objectSpread({
                    size: "lg",
                    emphasis: "high",
                    width: "290px",
                    onClick: function() {
                        onChange({
                            date: date,
                            time: time
                        });
                        closeModal(false);
                    },
                    disabled: !date || !time
                }, tracking/* default.tagGTM */.Z.tagGTM("visit_date_popup_submit_button")), {
                    children: "확인"
                }))
            })
        ]
    }));
};
/* harmony default export */ var VisitConsult_DateTimePopup = (DateTimePopup);
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__Box",
    componentId: "sc-bbc8d2ff-0"
})(DateTimePopup_templateObject());
var ContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__ContentWrap",
    componentId: "sc-bbc8d2ff-1"
})(DateTimePopup_templateObject1());
var CalendarBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__CalendarBox",
    componentId: "sc-bbc8d2ff-2"
})(DateTimePopup_templateObject2());
var TimeBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__TimeBox",
    componentId: "sc-bbc8d2ff-3"
})(DateTimePopup_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(DateTimePopup_templateObject3(), theme.colors.natural_color.gray[100]);
});
var TimeListBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__TimeListBox",
    componentId: "sc-bbc8d2ff-4"
})(DateTimePopup_templateObject5(), common/* CustomScroll */.c);
var TimeCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__TimeCard",
    componentId: "sc-bbc8d2ff-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(DateTimePopup_templateObject6(), theme.colors.natural_color.gray[200]);
});
var BtnContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DateTimePopup__BtnContainer",
    componentId: "sc-bbc8d2ff-6"
})(_templateObject8());

// EXTERNAL MODULE: ./src/providers/ModalProvider/ModalProvider.tsx + 1 modules
var ModalProvider = __webpack_require__(72244);
// EXTERNAL MODULE: ./src/di-container/remodeling-manager/visit-consult/gateway/client.ts
var client = __webpack_require__(67410);
// EXTERNAL MODULE: ./src/hooks/useAuthenticated.ts
var useAuthenticated = __webpack_require__(90457);
// EXTERNAL MODULE: ./src/providers/PopupProvider/PopupProvider.tsx + 1 modules
var PopupProvider = __webpack_require__(42677);
// EXTERNAL MODULE: ../../.yarn/cache/yup-npm-1.1.1-b11d3f4437-2245b64f70.zip/node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(6459);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@hookform-resolvers-virtual-ca2d04ee65/0/cache/@hookform-resolvers-npm-3.1.0-8f7cf259db-8f6690e514.zip/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(11094);
;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/hook/ReserveFormHook.ts
function ReserveFormHook_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReserveFormHook_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReserveFormHook_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var InitValues = {
    agreement: undefined,
    channel: undefined,
    comment: "",
    images: [],
    itemType: null,
    simpleUserAgent: "PC_WEB",
    userName: "",
    userTel: "",
    visitDate: "",
    visitShop: undefined,
    visitTimeType: undefined
};
var quickConsultFormSchema = yup_index_esm/* object */.Ry().shape({
    visitDate: yup_index_esm/* string */.Z_().required("해당 항목은 필수값 입니다."),
    visitTimeType: yup_index_esm/* string */.Z_().required("방문 시간을 입력해주세요."),
    agree: yup_index_esm/* boolean */.O7().isTrue("개인정보 수집 및 이용에 관한 동의를 해주세요"),
    userName: yup_index_esm/* string */.Z_().required("해당 항목은 필수값 입니다.").min(1, "최소 1글자 입니다.").max(20, "최대 20글자까지만 입력가능합니다").matches(/^[a-zA-Z가-힣\s]{1,20}$/g, {
        message: "이름을 정확히 입력해 주세요."
    }),
    userTel: yup_index_esm/* string */.Z_().required("휴대폰번호를 입력해 주세요").min(12, "휴대폰번호를 정확히 입력해 주세요.").max(13)
});
var ReserveFormHook = function(option) {
    return (0,index_esm/* useForm */.cI)(ReserveFormHook_objectSpread({
        defaultValues: InitValues,
        resolver: (0,yup/* yupResolver */.X)(quickConsultFormSchema),
        mode: "onSubmit"
    }, option));
};
/* harmony default export */ var hook_ReserveFormHook = (ReserveFormHook);

// EXTERNAL MODULE: ./src/di-container/axios.ts
var axios = __webpack_require__(43856);
// EXTERNAL MODULE: ../../shared/remodeling-manager/src/index.ts + 7 modules
var src = __webpack_require__(31376);
;// CONCATENATED MODULE: ./src/di-container/remodeling-manager/consult/gateway/client.ts


var consultGateway = function() {
    return {
        createImg: new src/* UploadConsultTempImageGateway */.B_(axios/* axios */.o)
    };
};

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(98749);
// EXTERNAL MODULE: ./src/di-container/shop/detail/gateway/client.ts
var gateway_client = __webpack_require__(55627);
// EXTERNAL MODULE: ./src/hooks/useDataLayer.ts
var useDataLayer = __webpack_require__(55806);
// EXTERNAL MODULE: ./src/constants/index.ts + 7 modules
var constants = __webpack_require__(14054);
// EXTERNAL MODULE: ./src/providers/BrazeProvider/index.tsx + 1 modules
var BrazeProvider = __webpack_require__(53590);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.29.3-fef7e3c72c-e01cf5b62a.zip/node_modules/date-fns/esm/format/index.js + 6 modules
var format = __webpack_require__(22969);
;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/hook/useVisitConsult.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useVisitConsult_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useVisitConsult_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useVisitConsult_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useVisitConsult_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useVisitConsult_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useVisitConsult_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




















var NOT_NUMBER_REGEX = /[^0-9]/g;
var TEL_FORM_REGEX_10 = /^(\d{0,3})(\d{0,3})(\d{0,4})$/g;
var TEL_FORM_REGEX_11 = /^(\d{0,3})(\d{0,4})(\d{0,4})$/g;
var REGEX = /(-{1,2})$/g;
var MAX_SIZE = 10 * 1024 * 1024;
var useVisitConsult = function(param) {
    var shopId = param.shopId;
    var ref, ref1;
    var method = hook_ReserveFormHook();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)([]), items = ref2[0], setItems = ref2[1];
    var ref3 = (0,react.useState)([]), times = ref3[0], setTimes = ref3[1];
    var ref4 = (0,react.useState)(), minDate = ref4[0], setMinDate = ref4[1];
    var ref5 = (0,react.useState)(), maxDate = ref5[0], setMaxDate = ref5[1];
    var ref6 = (0,PopupProvider/* usePopup */.B)(), handleOpen = ref6.handleOpen, handleClose = ref6.handleClose;
    var ref7 = (0,ModalProvider/* useModal */.d)(), modalOpen = ref7.handleOpen;
    var ref8 = (0,ModalProvider/* useModal */.d)(), acceptModal = ref8.handleOpen;
    var ref9 = (0,ModalProvider/* useModal */.d)(), sizeLimitModal = ref9.handleOpen;
    var handlePushAndRemove = (0,useDataLayer/* useDataLayer */.P)().handlePushAndRemove;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var isProcessing = (0,react.useRef)(false);
    var channelType = router.query.channelType;
    var channelId = router.query.channelId === "undefined" ? "" : router.query.channelId;
    var channelUrl = router.query.channelUrl;
    var returnUrl = router.query.returnUrl;
    var ref10 = (0,dist/* default */.ZP)({
        shopId: shopId
    }, function() {
        return (0,gateway_client/* shopDetailGateway */.f)().getDetail.exec({
            shopId: shopId,
            typeValue: "MOBILE"
        });
    }), shopDetailResponse = ref10.data;
    var shopDetail = (0,react.useMemo)(function() {
        return shopDetailResponse === null || shopDetailResponse === void 0 ? void 0 : shopDetailResponse.data;
    }, [
        shopDetailResponse
    ]);
    var ref11 = (0,dist/* default */.ZP)("shop/display-search?channelId=".concat(channelId), function(_) {
        return (0,client/* visitConsultGateway */.P)().getChannel.exec({
            channelId: channelId,
            channelType: channelType,
            channelUrl: channelUrl
        });
    }), channelInfoResponse = ref11.data;
    var channelInfoData = (0,react.useMemo)(function() {
        var ref;
        return channelInfoResponse === null || channelInfoResponse === void 0 ? void 0 : (ref = channelInfoResponse.data) === null || ref === void 0 ? void 0 : ref.channel;
    }, [
        channelInfoResponse === null || channelInfoResponse === void 0 ? void 0 : (ref = channelInfoResponse.data) === null || ref === void 0 ? void 0 : ref.channel
    ]);
    var setValue = method.setValue, getValues = method.getValues, watch = method.watch;
    var nextImgId = (0,react.useRef)(1);
    var isKindListView = (0,react.useMemo)(function() {
        var ref;
        return (shopDetail === null || shopDetail === void 0 ? void 0 : (ref = shopDetail.type) === null || ref === void 0 ? void 0 : ref.code) === "S01" && !channelId && channelType === "OP20_01";
    }, [
        channelId,
        channelType,
        shopDetail
    ]);
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    var itemTypesFromUrlParams = (0,react.useMemo)(function() {
        var ref;
        return (ref = router.query) === null || ref === void 0 ? void 0 : ref.itemTypes;
    }, [
        (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.itemTypes
    ]);
    var handleSubmitData = (0,react.useCallback)(function(data) {
        var ref;
        var reqData = (0,lodash.cloneDeep)(data);
        if (isProcessing.current) {
            return;
        }
        isProcessing.current = true;
        (0,client/* visitConsultGateway */.P)().request.exec(useVisitConsult_objectSpreadProps(useVisitConsult_objectSpread({}, reqData), {
            visitTimeType: reqData.visitTimeType,
            userName: (ref = reqData.userName) === null || ref === void 0 ? void 0 : ref.trim(),
            itemType: reqData.itemType || itemTypesFromUrlParams || null
        })).then(function(data) {
            if (data.code === 200) {
                var ref;
                var _obj;
                handlePushAndRemove({
                    data: (_obj = {
                        event: constants/* GTM_CTA_REMO_EVENT_NAME */.EK6
                    }, useVisitConsult_defineProperty(_obj, constants/* GTM_CTA_KEY_NAME */.H7g, constants/* GTM_CSTC */.Ov9), useVisitConsult_defineProperty(_obj, constants/* GTM_KEY_NAME */.jGJ, constants/* GTM_VISIT_RESERVE_FIN */.Sc2), useVisitConsult_defineProperty(_obj, constants/* GTM_CST_KEYWORD */.GjS, constants/* GTM_VISIT_CONSULT_KEYWORD */.ap_), useVisitConsult_defineProperty(_obj, "consult_request_id", data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.visitConsultId), _obj),
                    key: constants/* GTM_KEY_NAME */.jGJ
                });
                logCustomEvent({
                    eventName: "bz_complete_arrange_visit_store",
                    eventProperties: {
                        bz_date: (0,format/* default */.Z)(new Date(), "yyyy-MM-dd"),
                        bz_store_type: lodash_default().get(shopDetail, "type.name", ""),
                        bz_store_area: lodash_default().get(shopDetail, "address.basic", ""),
                        bz_store_num: lodash_default().toString(lodash_default().get(shopDetail, "id", "")),
                        bz_store_name: lodash_default().get(shopDetail, "name", "")
                    }
                });
                modalOpen({
                    modalProps: {
                        hasIcon: false,
                        type: "alert",
                        text: "매장 상담 예약이 완료되었습니다.",
                        onConfirm: function() {
                            isProcessing.current = false;
                            if (returnUrl) {
                                router.push("".concat(returnUrl));
                            } else {
                                router.push("/shop/".concat(shopDetail.id));
                            }
                        }
                    }
                });
            }
        }).catch(function() {
            isProcessing.current = false;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        handlePushAndRemove,
        modalOpen,
        returnUrl,
        router,
        shopDetail,
        itemTypesFromUrlParams, 
    ]);
    var setItemCode = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,client/* visitConsultGateway */.P)().getItemCode.exec({
                        shopId: "".concat(shopId)
                    }).then(function(response) {
                        (response === null || response === void 0 ? void 0 : response.data) && setItems(response.data);
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        shopId
    ]);
    var setTimeCode = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,client/* visitConsultGateway */.P)().getTimeCode.exec().then(function(response) {
                        (response === null || response === void 0 ? void 0 : response.data) && setTimes(response.data);
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var handleChangeTelInput = (0,react.useCallback)(function(value) {
        if (value.length > 13) return;
        var tel = value.replace(NOT_NUMBER_REGEX, "").replace(value.length < 13 ? TEL_FORM_REGEX_10 : TEL_FORM_REGEX_11, "$1-$2-$3").replace(REGEX, "");
        setValue("userTel", tel);
    }, [
        setValue
    ]);
    var handleChangeName = function(e) {
        var value = e.currentTarget.value;
        if (value.trim().length === 0) {
            setValue("userName", value.replace(/^\s*/, "").replace(/\s*$/, ""));
        } else setValue("userName", value);
    };
    var handleSetDateTime = (0,react.useCallback)(function(e) {
        setValue("visitTimeType", e.time.code, {
            shouldValidate: true
        });
        setValue("visitDate", e.date, {
            shouldValidate: true
        });
    }, [
        setValue
    ]);
    var ref12 = (0,react.useState)(false), isNameDisabled = ref12[0], setIsNameDisabled = ref12[1];
    var ref13 = (0,react.useState)(false), isTelDisabled = ref13[0], setIsTelDisabled = ref13[1];
    var setLoggedInUserInfo = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,client/* visitConsultGateway */.P)().getBasic.exec().then(function(response) {
                        var ref;
                        var user = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.user;
                        var userName = (user === null || user === void 0 ? void 0 : user.name) || "";
                        var userTel = (user === null || user === void 0 ? void 0 : user.tel) || "";
                        if ((user === null || user === void 0 ? void 0 : user.simpleUserFlag) === "N") {
                            setValue("userName", userName, {
                                shouldValidate: true
                            });
                            setValue("userTel", userTel, {
                                shouldValidate: true
                            });
                            setIsNameDisabled(true);
                            setIsTelDisabled(true);
                        }
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        setValue
    ]);
    var handlePopupDateTime = (0,react.useCallback)(function() {
        handleOpen({
            popupProps: {
                title: "방문일시 선택",
                buttonType: "noneBtn",
                gtmName: "visit_date_popup",
                titleStyle: {
                    margin: "16px 28px 0px 28px",
                    paddingBottom: "8px"
                },
                wrapStyle: {
                    width: "909px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitConsult_DateTimePopup, {
                    times: times,
                    currentTime: watch("visitTimeType"),
                    currentDate: watch("visitDate"),
                    minDate: minDate,
                    maxDate: maxDate,
                    closeModal: handleClose,
                    onChange: handleSetDateTime
                })
            }
        });
    }, [
        handleOpen,
        times,
        watch,
        minDate,
        maxDate,
        handleClose,
        handleSetDateTime, 
    ]);
    var handleAgreement = (0,react.useCallback)(function() {
        handleOpen({
            popupProps: {
                title: "개인정보 수집 및 이용 동의",
                popupSize: "xxl",
                gtmName: "visit_consult_agree_popup",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementPopup_VisitPersonalInfoCollection, {
                    isEvent: false,
                    isMember: isAuthenticated
                })
            }
        });
    }, [
        handleOpen,
        isAuthenticated
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setValue("visitShop.shopId", shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.id, {
            shouldValidate: true
        });
        setValue("visitShop.shopName", shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.name, {
            shouldValidate: true
        });
        setValue("visitShop.shopType", shopDetail === null || shopDetail === void 0 ? void 0 : (ref = shopDetail.type) === null || ref === void 0 ? void 0 : ref.code, {
            shouldValidate: true
        });
        setValue("visitShop.shopCode", shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.shopCode, {
            shouldValidate: true
        });
    }, [
        setValue,
        shopDetail
    ]);
    var setDate = (0,react.useCallback)(function(year, month, date) {
        var calcMonth = "".concat(month < 10 ? "0" : "").concat(month);
        var calcDate = "".concat(date < 10 ? "0" : "").concat(date);
        setValue("visitDate", "".concat(year, "-").concat(calcMonth, "-").concat(calcDate));
    }, [
        setValue
    ]);
    var setTodayDate = (0,react.useCallback)(function() {
        if (getValues("visitDate")) return;
        var today = new Date();
        var maxDate = new Date(today);
        var minDate = new Date(today);
        minDate.setDate(today.getDate() + START_DATE_DIFF);
        maxDate.setDate(today.getDate() + SELECTABLE_DATE_RANGE + START_DATE_DIFF);
        setMinDate(minDate);
        setMaxDate(maxDate);
        setDate(minDate.getFullYear(), minDate.getMonth() + 1, minDate.getDate());
    }, [
        getValues,
        setDate
    ]);
    var isFileValidation = (0,react.useCallback)(function(file) {
        if (!(file.type.includes("png") || file.type.includes("gif") || file.type.includes("png") || file.type.includes("jpeg"))) {
            acceptModal({
                modalProps: {
                    text: "jpg, gif, png 파일만 업로드 가능합니다."
                }
            });
            return false;
        }
        if (file.size > MAX_SIZE) {
            sizeLimitModal({
                modalProps: {
                    text: "최대 10MB까지 업로드 가능 합니다."
                }
            });
            return false;
        }
        return true;
    }, [
        acceptModal,
        sizeLimitModal
    ]);
    var handleAddPictureList = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(file) {
            var formData, ref, imgData, url, prevList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isFileValidation(file)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        formData = new FormData();
                        formData.append("file", file);
                        _ctx.next = 6;
                        return consultGateway().createImg.exec(formData);
                    case 6:
                        ref = _ctx.sent;
                        imgData = ref.data;
                        if (imgData) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 10:
                        url = imgData.fileUrl;
                        prevList = (0,lodash.cloneDeep)(getValues("images"));
                        if (prevList) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        setValue("images", _toConsumableArray(prevList).concat([
                            {
                                seq: nextImgId.current++,
                                url: url
                            }
                        ]));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getValues,
        isFileValidation,
        setValue
    ]);
    var handleRemovePictureFile = (0,react.useCallback)(function(id) {
        var ref;
        setValue("images", (ref = watch("images")) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return item.seq !== id;
        }));
    }, [
        setValue,
        watch
    ]);
    var isValid = (0,react.useMemo)(function() {
        if (!!watch("visitDate") && !!watch("visitTimeType") && watch("agreement.privacy") === "Y" && !!watch("userName") && !!watch("userTel")) {
            if (isKindListView) {
                if (watch("itemType")) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        } else {
            return false;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        watch("visitDate"),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        watch("visitTimeType"),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        watch("agreement.privacy"),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        watch("itemType"),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        watch("userName"),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        watch("userTel"), 
    ]);
    (0,react.useEffect)(function() {
        isAuthenticated && setLoggedInUserInfo();
        setItemCode();
        setTimeCode();
        setTodayDate();
    }, [
        isAuthenticated,
        setLoggedInUserInfo,
        setItemCode,
        setTimeCode,
        setTodayDate, 
    ]);
    (0,react.useEffect)(function() {
        if (channelType) {
            setValue("channel", {
                channelType: channelType,
                channelId: channelId || null,
                channelUrl: channelUrl
            });
        }
    }, [
        channelId,
        channelType,
        channelUrl,
        setValue
    ]);
    (0,react.useEffect)(function() {
        var _obj;
        handlePushAndRemove({
            data: (_obj = {
                event: constants/* GTM_CTA_REMO_EVENT_NAME */.EK6
            }, useVisitConsult_defineProperty(_obj, constants/* GTM_CTA_KEY_NAME */.H7g, constants/* GTM_CSTT */.BF4), useVisitConsult_defineProperty(_obj, constants/* GTM_KEY_NAME */.jGJ, constants/* GTM_VISIT_RESERVE_FIN */.Sc2), useVisitConsult_defineProperty(_obj, constants/* GTM_CST_KEYWORD */.GjS, constants/* GTM_VISIT_CONSULT_KEYWORD */.ap_), _obj),
            key: constants/* GTM_KEY_NAME */.jGJ
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        method: method,
        isValid: isValid,
        items: items,
        times: times,
        isKindListView: isKindListView,
        handleAgreement: handleAgreement,
        handleChangeTelInput: handleChangeTelInput,
        handlePopupDateTime: handlePopupDateTime,
        handleSubmitData: handleSubmitData,
        handleChangeName: handleChangeName,
        handleAddPictureList: handleAddPictureList,
        handleRemovePictureFile: handleRemovePictureFile,
        shopDetail: shopDetail,
        channelInfoData: channelInfoData,
        channelType: channelType,
        isNameDisabled: isNameDisabled,
        isTelDisabled: isTelDisabled
    };
};
/* harmony default export */ var hook_useVisitConsult = (useVisitConsult);

// EXTERNAL MODULE: ./src/components/Divider/index.ts
var Divider = __webpack_require__(95578);
;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/AgreeContent.tsx
function AgreeContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AgreeContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AgreeContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AgreeContent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function AgreeContent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        AgreeContent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var AgreeContent = function(param) {
    var handleAgreement = param.handleAgreement;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, watch = ref.watch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, AgreeContent_objectSpreadProps(AgreeContent_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_agree")), {
        display: "flex",
        flexDirection: "column",
        width: "570px",
        mt: "56px",
        mb: "70px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                variant: "body2",
                color: "color_chip.primary",
                display: "flex",
                alignContent: "center",
                flex: "1",
                children: "매장상담예약 개인정보 수집 이용 동의"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                mt: "30px",
                mb: "30px",
                h: "1px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* CheckBox */.Jg, AgreeContent_objectSpread({
                        size: 24,
                        onClick: function() {
                            setValue("agreement.privacy", watch("agreement.privacy") === "Y" ? "N" : "Y", {
                                shouldValidate: true
                            });
                        },
                        checked: watch("agreement.privacy") === "Y"
                    }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_agree_check_box_button"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        display: "flex",
                        flex: "1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "body2",
                                color: "color_chip.primary",
                                ml: "8px",
                                children: "개인정보 수집 및 이용에 관한 동의"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "body2",
                                color: "color_chip.red.500",
                                children: "(필수)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, AgreeContent_objectSpreadProps(AgreeContent_objectSpread({
                        emphasis: "low",
                        size: "sm",
                        width: "64px",
                        type: "button",
                        onClick: handleAgreement
                    }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_agree_popup_button")), {
                        children: "보기"
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ var VisitConsult_AgreeContent = (AgreeContent);

;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/DateTimeBtn.tsx
function DateTimeBtn_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DateTimeBtn_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DateTimeBtn_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DateTimeBtn_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function DateTimeBtn_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        DateTimeBtn_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function DateTimeBtn_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = DateTimeBtn_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function DateTimeBtn_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function DateTimeBtn_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DateTimeBtn_templateObject() {
    var data = DateTimeBtn_taggedTemplateLiteral([
        "\n    width: 100%;\n    border: none;\n    height: 100%;\n    padding: 14px 44px 14px 16px;\n    box-sizing: border-box;\n    cursor: pointer;\n    ::placeholder {\n      color: ",
        ";\n    }\n  "
    ]);
    DateTimeBtn_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DateTimeBtn_templateObject1() {
    var data = DateTimeBtn_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    DateTimeBtn_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DateTimeBtn = function(_param) {
    var onClick = _param.onClick, value = _param.value, props = DateTimeBtn_objectWithoutProperties(_param, [
        "onClick",
        "value"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, DateTimeBtn_objectSpreadProps(DateTimeBtn_objectSpread({
        onClick: onClick,
        position: "relative",
        width: "100%",
        height: "48px",
        borderRadius: "2px",
        border: "1px solid",
        borderColor: "color_chip.gray.200"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBox, {
                readOnly: true,
                value: value,
                placeholder: "날짜와 시간을 선택해 주세요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                position: "absolute",
                top: "16px",
                right: "12px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                    variant: "ic_arrow_down_bold",
                    size: 14,
                    resize: true
                })
            })
        ]
    }));
};
/* harmony default export */ var VisitConsult_DateTimeBtn = (DateTimeBtn);
var InputBox = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "DateTimeBtn__InputBox",
    componentId: "sc-8de8f216-0"
})(DateTimeBtn_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(DateTimeBtn_templateObject(), theme.colors.color_chip.gray[500]);
});

;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/PictureList.tsx
function PictureList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PictureList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PictureList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PictureList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PictureList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PictureList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PictureList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PictureList_templateObject() {
    var data = PictureList_taggedTemplateLiteral([
        "\n      display: block;\n      object-fit: fill;\n      width: 100%;\n      height: 100%;\n      border: 1px solid ",
        ";\n    "
    ]);
    PictureList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PictureList_templateObject1() {
    var data = PictureList_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    PictureList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PictureList_templateObject2() {
    var data = PictureList_taggedTemplateLiteral([
        "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: calc(20% - 6px);\n      aspect-ratio: 1/1;\n      border: 1px solid ",
        ";\n      cursor: pointer;\n    "
    ]);
    PictureList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PictureList_templateObject3() {
    var data = PictureList_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    PictureList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PictureList_templateObject4() {
    var data = PictureList_taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    PictureList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var PictureList = function(param) {
    var handleAddPictureList = param.handleAddPictureList, handleRemovePictureFile = param.handleRemovePictureFile;
    var ref;
    var watch = (0,index_esm/* useFormContext */.Gc)().watch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
        space: 8,
        children: [
            (ref = watch("images")) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                    position: "relative",
                    width: "calc(20% - 6px)",
                    style: {
                        aspectRatio: "1/1"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture, {
                            src: item.url || (0,utils/* getAsset */.Nh)("/assets/images/no_image.png"),
                            onError: function(param) {
                                var currentTarget = param.currentTarget;
                                currentTarget.src = (0,utils/* getAsset */.Nh)("/assets/images/no_image.png");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, PictureList_objectSpreadProps(PictureList_objectSpread({
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            top: "1px",
                            right: "1px",
                            width: "28px",
                            height: "28px",
                            backgroundColor: design_system_pc/* dimmed.dark.dimmed_50 */.KC.dark.dimmed_50,
                            style: {
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return handleRemovePictureFile(item.seq);
                            }
                        }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_form_picture_remove_button")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                variant: "ic_close_bold",
                                size: 16,
                                resize: true,
                                fillColor: "#ffffff"
                            })
                        }))
                    ]
                }, "picture-item-".concat(item.seq));
            }),
            watch("images").length < 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PictureAddBox, {
                as: "label",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                        variant: "ic_plus",
                        size: 36,
                        resize: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput, PictureList_objectSpreadProps(PictureList_objectSpread({
                        type: "file",
                        onChange: function(param) {
                            var target = param.target;
                            var ref, ref1;
                            if (!((ref = target.files) === null || ref === void 0 ? void 0 : ref[0])) return;
                            handleAddPictureList((ref1 = target.files) === null || ref1 === void 0 ? void 0 : ref1[0]);
                            target.value = "";
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_form_picture_add_button")), {
                        accept: ".gif, .jpg, .png"
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var VisitConsult_PictureList = (PictureList);
var Picture = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "PictureList__Picture",
    componentId: "sc-272be200-0"
})(PictureList_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(PictureList_templateObject(), theme.colors.color_chip.gray[200]);
});
var PictureAddBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "PictureList__PictureAddBox",
    componentId: "sc-272be200-1"
})(PictureList_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(PictureList_templateObject2(), theme.colors.color_chip.gray[200]);
});
var FileInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "PictureList__FileInput",
    componentId: "sc-272be200-2"
})(PictureList_templateObject4());

;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/FormContent.tsx
function FormContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FormContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FormContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FormContent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FormContent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FormContent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var FormContent = function(param) {
    var isNameDisabled = param.isNameDisabled, isTelDisabled = param.isTelDisabled, items = param.items, isKindListView = param.isKindListView, handlePopupDateTime = param.handlePopupDateTime, handleChangeTelInput = param.handleChangeTelInput, handleAddPictureList = param.handleAddPictureList, handleChangeName = param.handleChangeName, handleRemovePictureFile = param.handleRemovePictureFile;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, watch = ref.watch, register = ref.register, errors = ref.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, FormContent_objectSpreadProps(FormContent_objectSpread({
        width: "570px"
    }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_form")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                py: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                            offset: {
                                right: -8,
                                top: 0
                            },
                            size: "sm",
                            zIndex: 50,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "subTitle5",
                                color: "color_chip.primary",
                                children: "이름"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        py: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, FormContent_objectSpread({
                                flex: "1",
                                disabled: isNameDisabled,
                                placeholder: "이름 입력",
                                size: "lg"
                            }, register("userName", {
                                onChange: function(e) {
                                    return handleChangeName(e);
                                }
                            }))),
                            errors.userName && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "caption1",
                                color: "color_chip.red.500",
                                marginTop: "8px",
                                children: errors.userName.message
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                py: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                            offset: {
                                right: -8,
                                top: 0
                            },
                            size: "sm",
                            zIndex: 50,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "subTitle5",
                                color: "color_chip.primary",
                                children: "휴대폰번호"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        py: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, {
                                placeholder: "숫자만 입력",
                                size: "lg",
                                disabled: isTelDisabled,
                                onChange: function(param) {
                                    var target = param.target;
                                    return handleChangeTelInput(target.value);
                                },
                                value: watch("userTel")
                            }),
                            errors.userTel && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "caption1",
                                color: "color_chip.red.500",
                                marginTop: "8px",
                                children: errors.userTel.message
                            })
                        ]
                    })
                ]
            }),
            isKindListView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                py: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                            offset: {
                                right: -8,
                                top: 0
                            },
                            size: "sm",
                            zIndex: 50,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "subTitle5",
                                color: "color_chip.primary",
                                children: "상담 품목"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        display: "flex",
                        flexWrap: "wrap",
                        width: "100%",
                        style: {
                            columnGap: "24px",
                            rowGap: "16px"
                        },
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* RadioButton */.EU, FormContent_objectSpread({
                                labelOptions: {
                                    text: item.name,
                                    textVariant: "body1"
                                },
                                disabled: false,
                                checked: watch("itemType") === item.code,
                                onClick: function() {
                                    return setValue("itemType", item.code);
                                }
                            }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_form_kind_dropdown_item_button", {
                                "option-value": item.code
                            })), item.code);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                py: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                            offset: {
                                right: -8,
                                top: 0
                            },
                            size: "sm",
                            zIndex: 50,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "subTitle5",
                                color: "color_chip.primary",
                                children: "방문 일시"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitConsult_DateTimeBtn, FormContent_objectSpread({
                            onClick: handlePopupDateTime,
                            value: watch("visitDate") !== undefined && watch("visitTimeType") !== undefined ? "".concat(watch("visitDate").replaceAll("-", "."), " / ").concat((0,utils_date/* formatTimeCode */.fF)(watch("visitTimeType"))) : ""
                        }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_form_open_visit_date_popup_button")))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                py: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "subTitle5",
                            color: "color_chip.primary",
                            children: "남기고 싶은 말 (선택)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        py: "4px",
                        textAlign: "right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Textarea */.gx, FormContent_objectSpread(FormContent_objectSpreadProps(FormContent_objectSpread({
                                minHeight: "148px"
                            }, register("comment", {
                                onChange: function(param) {
                                    var target = param.target;
                                    return target.value.length < 300 ? setValue("comment", target.value) : setValue("comment", target.value.slice(0, 300));
                                }
                            })), {
                                placeholder: "상담사에게 전달하고 싶은 말을 남겨주세요. (예시: 좋아하는 색상, 원하는 스타일, 별도의 요청사항 등)"
                            }), register("comment"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                variant: "caption1",
                                color: "color_chip.gray.500",
                                mt: "8px",
                                children: [
                                    "(",
                                    watch("comment").length,
                                    "/300)"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                py: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "subTitle5",
                            color: "color_chip.primary",
                            children: "사진 첨부 (최대 5장)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        py: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitConsult_PictureList, {
                            handleAddPictureList: handleAddPictureList,
                            handleRemovePictureFile: handleRemovePictureFile
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var VisitConsult_FormContent = (FormContent);

// EXTERNAL MODULE: ./src/components/FloatingGroup/index.tsx + 1 modules
var FloatingGroup = __webpack_require__(50724);
;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/VisitConsult.tsx
function VisitConsult_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VisitConsult_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VisitConsult_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function VisitConsult_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function VisitConsult_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        VisitConsult_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














var VisitConsult = function(param) {
    var shopId = param.shopId;
    var ref, ref1, ref2;
    var ref3 = hook_useVisitConsult({
        shopId: shopId
    }), handleSubmitData = ref3.handleSubmitData, isValid = ref3.isValid, method = ref3.method, items = ref3.items, isKindListView = ref3.isKindListView, handleChangeTelInput = ref3.handleChangeTelInput, handlePopupDateTime = ref3.handlePopupDateTime, handleAgreement = ref3.handleAgreement, handleChangeName = ref3.handleChangeName, handleAddPictureList = ref3.handleAddPictureList, handleRemovePictureFile = ref3.handleRemovePictureFile, times = ref3.times, shopDetail = ref3.shopDetail, channelType = ref3.channelType, channelInfoData = ref3.channelInfoData, isNameDisabled = ref3.isNameDisabled, isTelDisabled = ref3.isTelDisabled;
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    var isOpenhouse = (shopDetail === null || shopDetail === void 0 ? void 0 : (ref = shopDetail.type) === null || ref === void 0 ? void 0 : ref.code) === "S11";
    (0,react.useEffect)(function() {
        if (!shopDetail) return;
        logCustomEvent({
            eventName: "bz_start_arrange_visit_store",
            eventProperties: {
                bz_date: (0,format/* default */.Z)(new Date(), "yyyy-MM-dd"),
                bz_store_type: lodash_default().get(shopDetail, "type.name", "no type"),
                bz_store_area: lodash_default().get(shopDetail, "address.basic", "no area"),
                bz_store_num: lodash_default().toString(lodash_default().get(shopDetail, "id", "no shopId")),
                bz_store_name: lodash_default().get(shopDetail, "name", "no name")
            }
        });
    }, [
        logCustomEvent,
        shopDetail
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, VisitConsult_objectSpreadProps(VisitConsult_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("visit_consult")), {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mb: "100px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, VisitConsult_objectSpreadProps(VisitConsult_objectSpread({}, method), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                    position: "relative",
                    as: "form",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: "105px",
                    onSubmit: method.handleSubmit(handleSubmitData),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "subTitle2",
                            color: "color_chip.primary",
                            marginBottom: "20px",
                            children: "매장 상담 예약"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "headline4",
                            color: "color_chip.primary",
                            marginBottom: "8px",
                            children: "최대 할인 혜택과 공간 스타일링 제안을 받아보세요."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                            style: {
                                marginBottom: "48px"
                            },
                            width: "100%",
                            src: (0,utils/* getAsset */.Nh)("/assets/images/visit-consult/request/brand_values_banner.webp")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                            width: "570px",
                            borderRadius: "4px",
                            mb: "76px",
                            border: "1px solid",
                            borderColor: "color_chip.gray.100",
                            backgroundColor: "color_chip.gray.40",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                    space: 20,
                                    padding: 16,
                                    className: "shop-info-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                            width: "80px",
                                            height: "80px",
                                            display: "flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                                src: shopDetail === null || shopDetail === void 0 ? void 0 : (ref1 = shopDetail.mainImages) === null || ref1 === void 0 ? void 0 : ref1[0].url,
                                                borderRadius: "2px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                            display: "flex",
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "subTitle5",
                                                    color: "color_chip.gray.700",
                                                    children: (shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.name) || ""
                                                }),
                                                !isOpenhouse && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "body1",
                                                    color: "color_chip.gray.600",
                                                    children: (shopDetail === null || shopDetail === void 0 ? void 0 : (ref2 = shopDetail.type) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (channelInfoData === null || channelInfoData === void 0 ? void 0 : channelInfoData.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                    space: 4,
                                    borderTop: "1px solid",
                                    borderColor: "color_chip.gray.100",
                                    padding: "8px 16px",
                                    color: "color_chip.gray.600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                        variant: "body2",
                                        children: [
                                            "[",
                                            channelInfoData.channelName,
                                            "] ",
                                            channelInfoData.title
                                        ]
                                    })
                                })
                            ]
                        }),
                        isOpenhouse && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            width: 170,
                            position: "absolute",
                            top: "103px",
                            left: "701px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                src: (0,utils/* getAsset */.Nh)("/assets/images/visit-consult/request/open_house_banner.png"),
                                borderRadius: "2px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitConsult_FormContent, {
                            isNameDisabled: isNameDisabled,
                            isTelDisabled: isTelDisabled,
                            handlePopupDateTime: handlePopupDateTime,
                            items: items,
                            times: times,
                            handleChangeTelInput: handleChangeTelInput,
                            isKindListView: isKindListView,
                            channelType: channelType,
                            handleChangeName: handleChangeName,
                            handleAddPictureList: handleAddPictureList,
                            handleRemovePictureFile: handleRemovePictureFile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitConsult_AgreeContent, {
                            handleAgreement: handleAgreement
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, VisitConsult_objectSpreadProps(VisitConsult_objectSpread({
                            size: "lg",
                            emphasis: "high",
                            width: "570px",
                            type: "submit",
                            disabled: !isValid
                        }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_reservation_button")), {
                            children: "예약하기"
                        }))
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingGroup/* FloatingGroup */.X, VisitConsult_objectSpread({
                onlyTopButton: true
            }, tracking/* default.tagGTM */.Z.tagGTM("visit_consult_scroll_top_button")))
        ]
    }));
};
/* harmony default export */ var VisitConsult_VisitConsult = (VisitConsult);

;// CONCATENATED MODULE: ./src/feat-components/VisitConsult/index.ts


;// CONCATENATED MODULE: ./pages/visit-consult/request.tsx
function request_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function request_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            request_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var VisitConsultRequestPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        isGnbExist: false,
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitConsult_VisitConsult, request_objectSpread({}, props))
    });
};
var __N_SSP = true;
/* harmony default export */ var request = (VisitConsultRequestPage);


/***/ }),

/***/ 50724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ FloatingGroup_FloatingGroup; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-0bfff5899a/0/cache/@design-system-pc-npm-4.5.5-5209ca23ee-508cb735dc.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(56341);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingGroup.tsx
/* provided dependency */ var process = __webpack_require__(98822);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  position: absolute;\n  right: 0;\n  bottom: ",
        ";\n  transition: bottom 0.4s ease;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  transform: scale(",
        ");\n  transition: transform 0.2s;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var FloatingGroup = function(param) {
    var onlyTopButton = param.onlyTopButton, zIndex = param.zIndex;
    var router = (0,next_router.useRouter)();
    var rootRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isShow = ref[0], setIsShow = ref[1];
    var ref1 = (0,react.useState)(0), scrollY = ref1[0], setScrollY = ref1[1];
    var handleClickScrollTop = (0,react.useCallback)(function() {
        if (!(rootRef === null || rootRef === void 0 ? void 0 : rootRef.current)) return;
        rootRef.current.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    var handleWatchScroll = (0,lodash.throttle)(function() {
        var ref;
        var ref1;
        var currentScrollY = (ref1 = rootRef === null || rootRef === void 0 ? void 0 : (ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.scrollY) !== null && ref1 !== void 0 ? ref1 : 0;
        setScrollY(currentScrollY);
    }, 300);
    var handleChangeButtonExposure = (0,react.useCallback)(function() {
        var exposurePoint = (window === null || window === void 0 ? void 0 : window.innerHeight) / 3;
        setIsShow(scrollY > exposurePoint);
    }, [
        scrollY
    ]);
    var handleGoQuickConsult = (0,react.useCallback)(function() {
        router.push(// `${process.env.NEXT_PUBLIC_REMODELING_WEB_HOST}/quick-consult/request?channelType=OPKG_02`,
        "".concat(process.env.NEXT_PUBLIC_REMODELING_WEB_HOST, "/seq-consult?channelType=OP11_02"));
    }, [
        router
    ]);
    var initScrollEvent = function() {
        rootRef.current = window;
        rootRef.current.addEventListener("scroll", handleWatchScroll);
    };
    var destroyScrollEvent = function() {
        if ((rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null) return;
        rootRef.current.removeEventListener("scroll", handleWatchScroll);
    };
    (0,react.useEffect)(function() {
        initScrollEvent();
        return function() {
            destroyScrollEvent();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        handleChangeButtonExposure();
    }, [
        handleChangeButtonExposure
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
        position: "fixed",
        right: 80,
        bottom: 40,
        width: 72,
        height: 72,
        zIndex: zIndex || styles/* TOP_BUTTON_Z_INDEX */.xH,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [
            !onlyTopButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultButton, _objectSpreadProps(_objectSpread({
                onClick: handleGoQuickConsult,
                isShow: isShow
            }, tracking/* default.tagGTM */.Z.tagGTM("quick_consult_button")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                    variant: "headline7",
                    color: "color_chip.white",
                    children: [
                        "상담",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "신청"
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopButtonWrapper, _objectSpreadProps(_objectSpread({
                className: "scroll-top-wrapper",
                isShow: isShow,
                width: 52,
                height: 52,
                position: "absolute",
                right: "10px",
                bottom: "0"
            }, tracking/* default.tagGTM */.Z.tagGTM("scroll_top_button")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopButton, {
                    onClick: handleClickScrollTop,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* IconButton */.hU, {
                        size: "lg",
                        variant: "ic_arrow_top"
                    })
                })
            }))
        ]
    });
};
/* harmony default export */ var FloatingGroup_FloatingGroup = (FloatingGroup);
var ConsultButton = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingGroup__ConsultButton",
    componentId: "sc-aa88ebcf-0"
})(_templateObject(), function(props) {
    return props.theme.colors.color_chip.primary;
}, function(param) {
    var isShow = param.isShow;
    return isShow ? "66px" : 0;
});
var ScrollTopButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingGroup__ScrollTopButtonWrapper",
    componentId: "sc-aa88ebcf-1"
})(_templateObject1(), function(param) {
    var isShow = param.isShow;
    return isShow ? 1 : 0;
});
var ScrollTopButton = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingGroup__ScrollTopButton",
    componentId: "sc-aa88ebcf-2"
})(_templateObject2(), function(props) {
    return props.theme.colors.color_chip.white;
}, function(props) {
    return props.theme.colors.color_chip.gray[100];
});

;// CONCATENATED MODULE: ./src/components/FloatingGroup/index.tsx




/***/ }),

/***/ 67410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ visitConsultGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31376);


var visitConsultGateway = function() {
    return {
        request: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .CreateVisitConsultRequestReservationGateway */ .o3(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getTimeCode: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetVisitConsultTimeCodeGateway */ .Vu(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getItemCode: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetVisitConsultItemCodeGateway */ .h(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getUserInfo: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetVisitConsultUserInfoGateway */ .Dx(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getReservationList: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetVisitConsultUsersReservationGateway */ .Bz(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getChannel: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetVisitConsultChannelInfoGateway */ ._S(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        cancelReservation: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .CancelVisitConsultUsersReservationGateway */ .Vs(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getBasic: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetVisitConsultBasicInfoGateway */ .Sk(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 55627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ shopDetailGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83651);


var shopDetailGateway = function() {
    return {
        getDetail: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopDetailGateway */ .UU(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getConsultantList: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopConsultantGateway */ .N5(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getApartRanksList: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetApartRanksGateway */ .JG(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getAgents: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetAgencyAgentsDetailGateway */ .wk(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 77561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ formatTimePeriod; },
/* harmony export */   "fF": function() { return /* binding */ formatTimeCode; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; }
/* harmony export */ });
/* unused harmony exports parseDateTime, parseDate, formatDate */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13173);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22969);

var parseDateTime = function(value) {
    return value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, "yyyy-MM-dd HH:mm:ss", new Date()) : undefined;
};
var formatDateTime = function(value, formatString) {
    var date = parseDateTime(value);
    return date ? (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, formatString) : undefined;
};
var parseDate = function(value) {
    return value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
};
var formatDate = function(value, formatString) {
    var date = parseDate(value);
    return date ? format(date, formatString) : undefined;
};
var formatTimePeriod = function(value) {
    var period = value < 12 || value === 24 ? "오전" : "오후";
    var time = value > 12 ? value - 12 : value;
    return "".concat(period, " ").concat(time, "시");
};
var formatTimeCode = function(timeCode) {
    if (!timeCode || typeof timeCode === "number") return "";
    var value = Number(timeCode.substring(1));
    var period = value < 12 || value === 24 ? "오전" : "오후";
    var time = value > 12 ? value - 12 : value;
    return "".concat(period, " ").concat(time, "시");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9344,8974,5114,4453,378,2413,1376,3651,3375,9774,2888,179], function() { return __webpack_exec__(25216); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);